import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useUser } from "../../../contexts/userContext";

const CompanyAdminRoute = () => {
  const { user } = useUser();

  return [5, 8].includes(Number(user?.access_level)) ? (
    <Outlet />
  ) : (
    <Navigate to="/home" replace />
  );
};

export default CompanyAdminRoute;
